import React from 'react';
import {Outlet} from 'react-router-dom';

import {AppstoreOutlined, ControlTwoTone} from '@/icons';
import AuthRoute from '../AuthRoute';
import RouteRedirect from '@/app/wrapper/RouteRedirect';

import CustomPage from '@/page/customer/CustomPage';
import ConsentPage from '@/page/customer/ConsentPage';
import CustomerTagPage from '@/page/customer/CustomerTagPage';
import RoomPage from '@/page/customer/RoomPage';
import WelcomPage from '@/page/customer/WelcomPage';
import RoomWelcomPage from '@/page/customer/RoomWelcomPage';
import OnPage from '@/page/customer/InheritPage/OnPage';
import QuitPage from '@/page/customer/InheritPage/QuitPage';
import TransferPage from '@/page/customer/TransferPage';
import LossPage from '@/page/customer/LossPage';
import MomentPage from '@/page/customer/MomentPage';
import SendMoment from '@/page/customer/MomentPage/SendMoment';
import MsgSend from '@/page/customer/MsgPage/Send';
import MsgList from '@/page/customer/MsgPage/List';
import StatisticPage from '@/page/customer/StatisticPage';
import MyIcon from '@/app/MyIcon';

const customerMenu = {
    icon: <ControlTwoTone />,
    title: '客户管理',
    path: 'customer',
    element: <Outlet />,

    children: [
        {
            index: true,
            element: <RouteRedirect menuKey="customerMenu" />,
        },

        {
            label: '客户管理',
            path: 'manage',
            icon: <MyIcon type="icon-kehuguanli" />,
            authorities: ['global:customer_mgr:r', 'global:customer_mgr:w'],
            element: (
                <AuthRoute onAuthorities={['global:customer_mgr:r', 'global:customer_mgr:w']}>
                    <CustomPage />
                </AuthRoute>
            ),
        },

        {
            label: '客户标签管理',
            path: 'tag',
            icon: <MyIcon type="icon-kehubiaoqianguanli" />,
            authorities: ['global:customer_tag:r', 'global:customer_tag:w'],
            element: (
                <AuthRoute onAuthorities={['global:customer_tag:r', 'global:customer_tag:w']}>
                    <CustomerTagPage />
                </AuthRoute>
            ),
        },

        {
            label: '客户群管理',
            path: 'room',
            icon: <MyIcon type="icon-kehuqunguanli" />,
            authorities: ['global:customer_room_mgr:r', 'global:customer_room_mgr:w'],
            element: (
                <AuthRoute
                    onAuthorities={['global:customer_room_mgr:r', 'global:customer_room_mgr:w']}
                >
                    <RoomPage />
                </AuthRoute>
            ),
        },
        {
            label: '欢迎语管理',
            path: 'welcom',
            icon: <MyIcon type="icon-kehuqunguanli" />,
            authorities: ['global:customer_welcome_mgr:r', 'global:customer_welcome_mgr:w'],
            element: (
                <AuthRoute
                    onAuthorities={[
                        'global:customer_welcome_mgr:r',
                        'global:customer_welcome_mgr:w',
                    ]}
                >
                    <WelcomPage />
                </AuthRoute>
            ),
        },
        {
            label: '群欢迎语管理',
            path: 'roomwelcom',
            icon: <MyIcon type="icon-kehuqunguanli" />,
            authorities: ['global:customer_room_welcom_mgr:r', 'global:customer_room_welcom_mgr:w'],
            element: (
                <AuthRoute
                    onAuthorities={[
                        'global:customer_room_welcom_mgr:r',
                        'global:customer_room_welcom_mgr:w',
                    ]}
                >
                    <RoomWelcomPage />
                </AuthRoute>
            ),
        },
        {
            label: '在职继承',
            path: 'on',
            icon: <MyIcon type="icon-zaizhijicheng" />,
            authorities: ['global:customer_onjob_inherit:r', 'global:customer_onjob_inherit:w'],
            element: (
                <AuthRoute
                    onAuthorities={[
                        'global:customer_onjob_inherit:r',
                        'global:customer_onjob_inherit:w',
                    ]}
                >
                    <OnPage />
                </AuthRoute>
            ),
        },
        {
            label: '离职继承',
            path: 'off',
            icon: <MyIcon type="icon-lizhijicheng" />,
            authorities: ['global:customer_offjob_inherit:r', 'global:customer_offjob_inherit:w'],
            element: (
                <AuthRoute
                    onAuthorities={[
                        'global:customer_offjob_inherit:r',
                        'global:customer_offjob_inherit:w',
                    ]}
                >
                    <QuitPage />
                </AuthRoute>
            ),
        },

        {
            label: '继承状态',
            path: 'transfer',
            icon: <MyIcon type="icon-jichengzhuangtai" />,
            authorities: ['global:customer_onoffjob_status:r', 'global:customer_onoffjob_status:w'],
            element: (
                <AuthRoute
                    onAuthorities={[
                        'global:customer_onoffjob_status:r',
                        'global:customer_onoffjob_status:w',
                    ]}
                >
                    <TransferPage />
                </AuthRoute>
            ),
        },

        {
            label: '客户流失',
            path: 'loss',
            icon: <MyIcon type="icon-kehuliushi" />,
            authorities: ['global:customer_loss:r', 'global:customer_loss:w'],
            element: (
                <AuthRoute onAuthorities={['global:customer_loss:r', 'global:customer_loss:w']}>
                    <LossPage />
                </AuthRoute>
            ),
        },

        {
            label: '朋友圈群发',
            path: 'momentSend',
            icon: <MyIcon type="icon-pengyouquanbeiqunfa" />,
            authorities: ['global:customer_moment_send:r'],
            element: (
                <AuthRoute onAuthorities={['global:customer_moment_send:r']}>
                    <SendMoment />
                </AuthRoute>
            ),
        },

        {
            label: '朋友圈',
            path: 'moment',
            icon: <MyIcon type="icon-pengyouquan1" />,
            authorities: ['global:customer_moment:r'],
            element: (
                <AuthRoute onAuthorities={['global:customer_moment:r']}>
                    <MomentPage />
                </AuthRoute>
            ),
        },

        {
            label: '消息群发',
            path: 'msg',
            icon: <MyIcon type="icon-xiaoxiqunfa" />,
            authorities: ['global:customer_msg_send:r', 'global:customer_msg_send:w'],
            element: (
                <AuthRoute
                    onAuthorities={['global:customer_msg_send:r', 'global:customer_msg_send:w']}
                >
                    <MsgSend />
                </AuthRoute>
            ),
        },

        {
            label: '消息群发记录',
            path: 'msgList',
            icon: <MyIcon type="icon-xiaoxiqunfajilu" />,
            authorities: ['global:customer_msg_list:r', 'global:customer_msg_list:w'],
            element: (
                <AuthRoute
                    onAuthorities={['global:customer_msg_list:r', 'global:customer_msg_list:w']}
                >
                    <MsgList />
                </AuthRoute>
            ),
        },

        {
            label: '客户统计',
            path: 'statistic',
            icon: <MyIcon type="icon-kehutongji" />,
            authorities: ['global:customer_statistic:r'],
            element: (
                <AuthRoute onAuthorities={['global:customer_statistic:r']}>
                    <StatisticPage />
                </AuthRoute>
            ),
        },
    ],
};

export default customerMenu;
